import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFVideoPlayer } from '@/components/UI/svg/mm100';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({ type, customClass }: any) {
    const { useLang, useEffect, useState, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);
    let controller: any;
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap = {
        us: 'https://www.youtube.com/embed/w33bHOJXj3Y',
        jp: 'https://www.youtube.com/embed/DI00L_1F4OU',
        cn: {
            SD: 'https://videos.ecoflow.com/f8cd27641b9e473ba758667de7263ea5/ec6e41ab55d34c99aa3751290089d24c-6ec0cf0fe7f1dfee8e74589283eb2640-fd.mp4',
            HD: 'https://videos.ecoflow.com/f8cd27641b9e473ba758667de7263ea5/ec6e41ab55d34c99aa3751290089d24c-82705c91681c8fe281ca9547030f36ef-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/1729f9ab-1841dfdc70d-0004-9c91-e6d-40030.mp4',
        },
    };

    const playerVideo = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Kits - Simple Set Up',
            position: 'Product_2',
        });
        setShowEFVideoModal(true);
    };

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.kitG .video-box`,
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1.2, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });

        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.kitG} kitG ${customClass}`}>
            <div className="kit-ms1">{t('presale.product.kitG_ms1')}</div>
            <div className="kit-ms2">
                {type === 'rv'
                    ? t(locale === 'kr' ? 'presale.product.kitG_ms2_rv_h5' : 'presale.product.kitG_ms2_rv')
                    : t(locale === 'kr' ? 'presale.product.kitG_ms2_off_grid_h5' : 'presale.product.kitG_ms2_off_grid')}
            </div>
            {type === 'rv' && <div className="kit-ms3">{t('presale.product.kitG_ms3')}</div>}
            <div className="watch-video-btn" onClick={playerVideo}>
                {t('presale.product.watch_video')}
                <EFVideoPlayer className="icon" color="#2673ff" />
            </div>
            <div className="video-box">
                {videoEnterA && <EFVideo sources={['/video/mm100m/kitG_h5_1.webm', '/video/mm100/kitG_h5_1.mp4']} className="video kitG-video" />}
                <span className="text-left text">{t('presale.product.kitG_Others')}</span>
                <span className="text-right text">{t('presale.product.kitG_EcoFlow')}</span>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
